import styled from 'styled-components'

export const HintWrapper = styled.div`
  position: absolute;
  overflow: hidden;
  width: 0px;
  height: 0px;
  clip-path: inset(50%);
  user-slect: none;
  z-index: -1;
  display: ${({ isDisplay }) => (isDisplay ? 'block' : 'none')};
`
